import { cryptoKeyToBase64, encryptCryptoKeyWithAes, encryptCryptoKeyWithPublicKey, generateAesGcmKey, generateCryptoPairs, signPublicKey, } from '@lucidlink/ts-crypto/crypto';
import { webCrypto } from '@lucidlink/ts-crypto/web-crypto';
import { signWorkspaceCryptoTuple } from '#sdk/workspace-client/crypto/crypto-utils';
export const prepareInvitationCommon = async ({ adminKeys, workspaceCommonKey, workspaceId, everyonePrivateKey, workspaceSecretKey, invitationKeys: invitationKeysParam, }) => {
    const id = webCrypto.randomUUID();
    const [invitationKeys, invitationSecretKey] = await Promise.all([
        invitationKeysParam ?? generateCryptoPairs(),
        generateAesGcmKey(),
    ]);
    const publicKeyPromise = cryptoKeyToBase64(invitationKeys.encryptPair.publicKey);
    const ePrivateKeyByAdminKeyPromise = encryptCryptoKeyWithPublicKey(invitationKeys.encryptPair.privateKey, adminKeys.encryptPair.publicKey);
    const ePrivateKeyByInvitationSecretPromise = encryptCryptoKeyWithAes(invitationKeys.encryptPair.privateKey, invitationSecretKey);
    const ePrivateKeyBySsoSecretPromise = encryptCryptoKeyWithAes(invitationKeys.encryptPair.privateKey, workspaceSecretKey);
    const eInvitationSecretByAdminKeyPromise = encryptCryptoKeyWithPublicKey(invitationSecretKey, adminKeys.encryptPair.publicKey);
    const eWorkspaceCommonKeyByInvitationKeyPromise = encryptCryptoKeyWithPublicKey(workspaceCommonKey, invitationKeys.encryptPair.publicKey);
    const eEveryonePrivateKeyByInvitationKeyPromise = encryptCryptoKeyWithPublicKey(everyonePrivateKey, invitationKeys.encryptPair.publicKey);
    const sInvitationByAdminKeyPromise = signWorkspaceCryptoTuple({ id, workspaceId, publicKey: invitationKeys.encryptPair.publicKey }, adminKeys.signPair.privateKey);
    const sAdminPublicKeyByInvitationKeyPromise = signPublicKey(adminKeys.encryptPair.publicKey, invitationKeys.signPair.privateKey);
    return {
        invitation: {
            id,
            publicKey: await publicKeyPromise,
            ePrivateKeyByAdminKey: await ePrivateKeyByAdminKeyPromise,
            ePrivateKeyByInvitationSecret: await ePrivateKeyByInvitationSecretPromise,
            eInvitationSecretByAdminKey: await eInvitationSecretByAdminKeyPromise,
            ePrivateKeyBySsoSecret: await ePrivateKeyBySsoSecretPromise,
            eWorkspaceCommonKeyByInvitationKey: await eWorkspaceCommonKeyByInvitationKeyPromise,
            eEveryonePrivateKeyByInvitationKey: await eEveryonePrivateKeyByInvitationKeyPromise,
            sInvitationByAdminKey: await sInvitationByAdminKeyPromise,
            sAdminPublicKeyByInvitationKey: await sAdminPublicKeyByInvitationKeyPromise,
        },
        invitationKeys,
        invitationSecret: invitationSecretKey,
    };
};
